// src/components/ui/Pagination.jsx
export function Pagination({ currentPage, totalPages, onPageChange, disabled }) {
  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
  }
  const dots = 'relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-400 inset-ring inset-ring-gray-700 focus:outline-offset-0';
  const activeclass = 'relative z-10 inline-flex items-center bg-blue-600 px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500';
  const deactiveclass = 'cursor-pointer relative inline-flex items-center px-4 py-2 text-sm font-semibold inset-ring inset-ring-gray-700 hover:text-white hover:bg-blue-600 focus:z-20 focus:outline-offset-0';
  // Show limited page numbers for many pages (optional)
  const visiblePages = pages.slice(
    Math.max(0, currentPage - 3),
    Math.min(pages.length, currentPage + 5)
  );

  return (
    <div className="text-center mt-3">
      <nav aria-label="Pagination" className="isolate inline-flex -space-x-px rounded-md">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1 || disabled}
          className="enabled:hover:text-white enabled:cursor-pointer relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 inset-ring inset-ring-gray-700 enabled:hover:bg-blue-600 focus:z-20 focus:outline-offset-0"
        >
          <span className="sr-only">Previous</span>
          <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" className="size-5">
            <path d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z" clipRule="evenodd" fillRule="evenodd" />
          </svg>
        </button>

        {currentPage > 7 && totalPages > 11 && (
          <>
            <button onClick={() => onPageChange(1)} disabled={disabled} aria-current="page" className={deactiveclass}>1</button>
            <span className={dots}>...</span>
          </>
        )}

        {visiblePages.map(page => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={currentPage === page ? activeclass : deactiveclass} disabled={disabled}
          >
            {page}
          </button>
        ))}

        {currentPage < totalPages - 6 && totalPages > 11 && (
          <>
            <span className={dots}>...</span>
            <button onClick={() => onPageChange(totalPages)} disabled={disabled} aria-current="page" className={deactiveclass}>
              {totalPages}
            </button>
          </>
        )}

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages || disabled}
          className="enabled:cursor-pointer relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 inset-ring inset-ring-gray-700 enabled:hover:text-white enabled:hover:bg-blue-600 focus:z-20 focus:outline-offset-0">
          <span className="sr-only">Next</span>
          <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" className="size-5">
            <path d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clipRule="evenodd" fillRule="evenodd" />
          </svg>
        </button>
      </nav>
    </div>
  );
}